import { Component, OnInit } from '@angular/core';
import { NameValue } from '../../shared/models/shared.model';
import { DealerSignUpModel } from '../models/dealer-sign-up.model';
import { FormGroup } from '@angular/forms';
import { DealerSignUpService } from '../services/dealer-sign-up.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ImageUploadImageSetModel } from '../../image-admin/image-models/image-upload-image-set.model';

@Component({
  selector: 'app-dealer-sign-up-modal',
  templateUrl: './dealer-sign-up-modal.component.html',
  styleUrls: ['./dealer-sign-up-modal.component.css']
})
export class DealerSignUpModalComponent implements OnInit {

  states: Array<NameValue>;
  countries: Array<NameValue>;
  sponsorDealerPopupVisible = false;
  isLoading = true;
  activityText = 'Loading...';

  constructor(private service: DealerSignUpService ) { }

  ngOnInit() {
    this.isLoading = true;
    forkJoin(
      this.service.fetchStates(),
      this.service.fetchCountries(),
    ).subscribe(results => {
      this.states = results[0];
      this.countries = results[1];
      this.isLoading = false;

      var spinners = window.document.getElementsByClassName('sponsor-dealer-spinner') as HTMLCollectionOf<HTMLElement>;
      for(var sIdx = 0; sIdx < spinners.length; sIdx++) {
        spinners[sIdx].style.display = 'none';
      }
      
    });
  }

  public readonly myFormGroup: FormGroup;
  model: DealerSignUpModel = {
    isSubmitted: false,
    companyName: '',
    addr1: '',
    addr2: '',
    city: '',
    companyPhone: '',
    contactEmail: '',
    contactFirstName: '',
    contactLastName: '',
    contactPhone: '',
    state: null,
    zip: '',
    distributor: '',
    confirmationMessage: null,
    isErrored: false,
    isWaiting: false
  };
  async onSubmit(event: DealerSignUpModel) {
    // Copy model contents and remove unneeded fields
    this.model.isWaiting = true;
    const postObject = {
      state: event.state,
      city: event.city,
      companyName: event.companyName,
      companyPhone: event.companyPhone,
      contactEmail: event.contactEmail,
      contactPhone: event.contactPhone,
      zip: event.zip,
      addr1: event.addr1,
      addr2: event.addr2,
      contactFirstName: event.contactFirstName,
      contactLastName: event.contactLastName,
      distributor: event.distributor
    };
    await this.service.postDealerSignUp(postObject)
      .then(
        res => {
          this.model.confirmationMessage = 'Thank you for Signing up!';
          this.model.isWaiting = false;
          this.model.isSubmitted = true;
        }
      ).catch(err => {
          console.log(err);
          this.model.isWaiting = false;
          this.model.isErrored = true;
          this.model.confirmationMessage = err.error.message;
        }
      );
  }

  showSponsorDealerModal() {
    this.sponsorDealerPopupVisible = true;
  }

  hideSponsorDealerModal() {
    this.sponsorDealerPopupVisible = false;
  }

  closeHandler($event: DealerSignUpModel | any) {
      this.model = {
      isSubmitted: false,
      companyName: '',
      addr1: '',
      addr2: '',
      city: '',
      companyPhone: '',
      contactEmail: '',
      contactFirstName: '',
      contactLastName: '',
      contactPhone: '',
      state: null,
      zip: '',
      distributor: '',
      confirmationMessage: null,
      isErrored: false,
      isWaiting: false
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/dealer-sign-up/containers/dealer-sign-up-modal.component.ts